// @ts-ignore
import { dialogFadeLeaveDuration, fadeDuration, fadeRowLeaveDuration, fadeRowLeaveDelay, overlayFadeEnterDuration, overlayFadeLeaveDuration, overlayFadeLeaveDelay, renameSpinnerAnimationDelay, renameSpinnerAnimationDuration } from "!!sass-variable-loader!../assets/wows/stylesheets/core/_settings.animation.scss";

const parseCSSTime = (time: any) => {
  if (!time || !time.match(/^\d+ms$/)) {
    return 0;
  }
  return parseInt(time, 10);
};

export const dialogFadeLeaveTimeout = parseCSSTime(dialogFadeLeaveDuration);

export const fadeTimeout = parseCSSTime(fadeDuration);

export const fadeRowLeaveTimeout = parseCSSTime(fadeRowLeaveDuration) + parseCSSTime(fadeRowLeaveDelay);

export const overlayFadeEnterTimeout = parseCSSTime(overlayFadeEnterDuration);
export const overlayFadeLeaveTimeout = parseCSSTime(overlayFadeLeaveDuration) + parseCSSTime(overlayFadeLeaveDelay);
export const renameSpinnerAnimationEnterDuration = parseCSSTime(renameSpinnerAnimationDuration) + parseCSSTime(renameSpinnerAnimationDelay);
export const renameSpinnerAnimationLeaveDuration = parseCSSTime(renameSpinnerAnimationDuration);
export const renameSpinnerFadeEnterDuration = parseCSSTime(renameSpinnerAnimationDuration);
export const renameSpinnerFadeLeaveDuration = parseCSSTime(renameSpinnerAnimationDuration) + parseCSSTime(renameSpinnerAnimationDelay);